/**
 * Tidio helpers for Ask a Naturopath #live-chat CTAs.
 *
 * The Tidio widget script is loaded async from tidio-live-chat.liquid.
 * This file only opens the chat from inline CTAs and avoids dead-clicks
 * while the widget is still booting.
 */
(function hogTidioLiveChat() {
  const isAskNaturopathPage =
    window.HOG?.PAGE_TEMPLATE === 'page.ask-a-naturopath' ||
    document.body.classList.contains('template-page-ask-a-naturopath') ||
    window.location.pathname.includes('ask-a-naturopath');

  if (!isAskNaturopathPage) return;

  function setLiveChatCtaVisibility(visible) {
    document.querySelectorAll('a[href="#live-chat"]').forEach((link) => {
      link.style.display = visible ? '' : 'none';
      link.style.visibility = visible ? 'visible' : 'hidden';
    });
  }

  function whenTidioReady(cb) {
    if (
      window.tidioChatApi &&
      (typeof window.tidioChatApi.open === 'function' ||
        typeof window.tidioChatApi.popUpOpen === 'function')
    ) {
      cb();
      return;
    }

    const onReady = () => {
      document.removeEventListener('tidioChat-ready', onReady);
      cb();
    };
    document.addEventListener('tidioChat-ready', onReady, { once: true });

    let waited = 0;
    const maxWait = 15000;
    const step = 200;
    const poll = window.setInterval(() => {
      waited += step;
      if (
        window.tidioChatApi &&
        (typeof window.tidioChatApi.open === 'function' ||
          typeof window.tidioChatApi.popUpOpen === 'function')
      ) {
        window.clearInterval(poll);
        cb();
      } else if (waited >= maxWait) {
        window.clearInterval(poll);
        setLiveChatCtaVisibility(true);
      }
    }, step);
  }

  function openChat() {
    try {
      if (window.tidioChatApi && typeof window.tidioChatApi.open === 'function') {
        window.tidioChatApi.open();
      } else if (window.tidioChatApi && typeof window.tidioChatApi.popUpOpen === 'function') {
        window.tidioChatApi.popUpOpen();
      } else if (window.tidioChatApi && typeof window.tidioChatApi.show === 'function') {
        window.tidioChatApi.show();
      } else if (window.tidioChatApi && typeof window.tidioChatApi.display === 'function') {
        window.tidioChatApi.display(true);
      } else {
        const bubble =
          document.querySelector('[data-tidio-widget]') ||
          document.querySelector('.tidio-chat-widget, #tidio-chat-widget, .tidio-chat');
        if (bubble) bubble.click();
      }
    } catch (err) {
      // Tidio open failed
    }
  }

  function init() {
    setLiveChatCtaVisibility(false);

    whenTidioReady(() => setLiveChatCtaVisibility(true));

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList' && document.getElementById('tidio-chat')) {
          whenTidioReady(() => setLiveChatCtaVisibility(true));
          break;
        }
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });

    document.addEventListener(
      'click',
      (event) => {
        const link = event.target.closest('a[href="#live-chat"]');
        if (!link) return;

        event.preventDefault();
        whenTidioReady(openChat);
      },
      { passive: false }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
